import React from 'react';

import icon1 from '../../../images/icon/da-fea_icon01.svg';
import icon2 from '../../../images/icon/da-fea_icon02.svg';
import icon3 from '../../../images/icon/da-fea_icon03.svg';
import icon4 from '../../../images/icon/da-fea_icon04.svg';

import hicon from '../../../images/icon/flower-icon-blue.svg';

const Features = [
    {
        title: 'Limited industry visibility',
        des: 'Many businesses struggle to gain meaningful exposure to the right decision-makers and industry leaders.',
        icon: icon1,
        col: 'col-lg-4 col-md-6 fea-col',
    },
    {
        title: 'Low engagement',
        des: 'Events often fail to create genuine interaction, resulting in surface-level conversations with little impact.',
        icon: icon2,
        col: 'col-lg-2 col-md-6 fea-col',
    },
    {
        title: 'Disconnected stakeholders',
        des: 'Corporations, investors, and public-sector leaders rarely have focused platforms to collaborate effectively.',
        icon: icon3,
        col: 'col-lg-2 col-md-6 fea-col',
    },
    {
        title: 'Lack of strategic outcomes',
        des: 'Without the right structure, conferences miss opportunities to spark innovation and drive real business growth.',
        icon: icon4,
        col: 'col-lg-4 col-md-6 fea-col',
    },
];

const FeatureSection = () => {



    return (
        <section className="feature pt-150 pb-150" style={{ backgroundColor: '#f4f5fc' }}>
            <div className="container-fluid p-0">
                
                {/* Section Title */}
                <div className="row justify-content-center">
                    <div className="col-xl-5 col-lg-8">
                        <div className="da-sec-titlte text-center mb-70">
                            <span className="sub_title">
                                <span>
                                    <img src={hicon} alt="" />
                                </span>
                                Challenge
                            </span>
                            <h2 className="title">
                                Turning conferences into meaningful platforms for growth and innovation
                            </h2>
                        </div>
                    </div>
                </div>

                {/* Features */}
                <div className="da-feature-wrap">
                    <div className="row g-0">
                        {Features.map((features, fitem) => (
                            <div className={features.col} key={fitem}>
                                <div className="da-feature-item">
                                    <div className="xb-item--holder">
                                        <div className="xb-item--icon">
                                            <img src={features.icon} alt="" />
                                        </div>
                                        <h3 className="xb-item--title">{features.title}</h3>
                                        <p className="xb-item--content">{features.des}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            

            </div>
        </section>
    );
};

export default FeatureSection;
